//#region libraries
import React, { useCallback, useEffect, useState, useMemo } from 'react'
//bootstrap
import { Col, Row } from 'react-bootstrap'
//tremor
import { Flex, List, Subtitle } from "@tremor/react";
//redux
import { useDispatch, useSelector } from 'react-redux';
import { assignEmployeesWorkZone, removeWorkzoneEmployees, selectAssignEmployeesWorkZoneStatus, selectRemoveWorkzoneEmployeesStatus } from '_redux/slices/timeline/employees';
import { selectAllTimelineAreas, selectSelectedTimeline } from '_redux/slices/timeline/timeline-areas';

import { Spacing } from '_styles';
//custom component
import EmployeeRow from './employee-row';
import { Virtuoso } from "react-virtuoso";

//#endregion

const EmployeesListCard = (props) => {

  //redux
  const dispatch = useDispatch()

  const allTimelineAreas = useSelector(selectAllTimelineAreas) ?? [];

  //#region states
  const [assignedEmployees, setAssignedEmployees] = useState([]);//employees staged for assignments
  const [removedEmployees, setRemovedEmployees] = useState([]);//employees staged for removals
  //#endregion

  //#region use effects

  // keep staged selections in sync with incoming employee props
  useEffect(() => {
    if (!Array.isFullArray(props.employees)) return;

    const normalize = (workZone) => {
      if (Array.isFullArray(workZone)) return workZone;
      if (workZone?._id) {
        return [{ id: workZone._id, label: workZone?.title ?? workZone?.label ?? "" }];
      }
      return [];
    };

    const syncSelections = (currentList) => {
      const mapped = new Map(currentList.map((emp) => [emp.employeeId, emp]));
      props.employees.forEach((employee) => {
        if (!mapped.has(employee.employeeId)) {
          mapped.set(employee.employeeId, {
            ...employee,
            workZone: normalize(employee?.workZone),
          });
        } else {
          const existing = mapped.get(employee.employeeId);
          mapped.set(employee.employeeId, {
            ...existing,
            workZone: normalize(existing?.workZone?.length ? existing.workZone : employee?.workZone),
          });
        }
      });
      return Array.from(mapped.values());
    };

    setAssignedEmployees((prev) => syncSelections(prev));
    setRemovedEmployees((prev) => syncSelections(prev));
  }, [props.employees]);
  //#endregion

  //#region employees function
  const getSelectedZones = (list, employee) => {
    const found = list?.find((item) => item?.employeeId === employee?.employeeId);
    if (Array.isFullArray(found?.workZone)) return found.workZone;
    if (employee?.workZone?._id) {
      return [{ id: employee.workZone._id, label: employee.workZone?.title ?? employee.workZone?.label ?? "" }];
    }
    return [];
  };

  const zoneOptions = Array.isFullArray(allTimelineAreas)
    ? allTimelineAreas.map((zone) => ({
      value: zone?._id,
      label: zone?.title ?? "",
    }))
    : [];

  // virtualised employees list for virtuoso
  const itemContent = useCallback((index) => {
    const employee = props?.employees[index];
    return (
      <EmployeeRow
        employee={employee}
        key={employee.employeeId}
        zoneOptions={zoneOptions}
        selectedZones={getSelectedZones(assignedEmployees, employee)}
      />
    )
  })
  //#endregion

  return (
    <Row>
      <Col xs={12} style={{ maxHeight: "60vh", minHeight: "60vh", overflowY: "auto" }}>
        <List>

          {/* employee list */}
          {Array.isFullArray(props.employees) && <Virtuoso
            style={{ height: '60vh' }}
            data={props.employees}
            overscan={100}
            itemContent={itemContent}
          />}

          {/* no employees message */}
          {!Array.isFullArray(props.employees) &&
            <div style={{ height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Subtitle>No employees found.</Subtitle>
            </div>
          }
        </List>
      </Col>

      {/* result info */}
      <div style={{ marginTop: Spacing.SCALE_12, marginBottom: Spacing.SCALE_12, display: 'flex', justifyContent: 'flex-end' }}>
        <Subtitle>{Array.isFullArray(props.employees) ? props.employees.length : 0} Employees</Subtitle>
      </div>

    </Row>
  )
}

export default EmployeesListCard
